<app-base-list-wrapper [baseListComponent]="this">
    <!-- <ng-template #moreButtons let-table="table">
        <p-button *ngIf="inEditingSig()" [outlined]="true" icon="fa-solid fa-check fa-sm"
            (click)="onRowEditSave(editFieldsArray[0], editRowIndex)" severity="primary"
            class=" p-button-text mr-1"></p-button>
        <p-button *ngIf="inEditingSig()" [outlined]="true" icon="fa-solid fa-times fa-sm"
            (click)="onRowEditCancel(editFieldsArray[0], editRowIndex)" severity="danger"
            class=" p-button-text"></p-button>
    </ng-template> -->
</app-base-list-wrapper>
